import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import { AppBar, Toolbar, Hidden } from "@material-ui/core";
import { Menu, MoreVert, ViewList } from "@material-ui/icons";
import HeaderLinks from "./HeaderLinks";
import Button from "../CustomButtons/Button";
import headerStyle from "../../assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";

function Header({ ...props }) {
  function makeBrand() {
    let name = '';
    props.routes.find((prop, key) => {
      if (prop.collapse) {
        prop.views.find((prop, key) => {
          if (prop.path === props.location.pathname) {
            name = prop.name;
            return true;
          }
          return false;
        });
      }
      if (prop.path === props.location.pathname) {
        name = prop.name;
        return true;
      }
      return false;
    });
    return name;
  }
  const { classes, color } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color
  });
  const sidebarMinimize =
    classes.sidebarMinimize
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <Button
                justIcon
                round
                color="white"
                onClick={props.sidebarMinimize}
              >
                <ViewList className={classes.miniIcon} />
              </Button>
            ) : (
                <Button
                  justIcon
                  round
                  color="white"
                  onClick={props.sidebarMinimize}
                >
                  <MoreVert className={classes.miniIcon} />
                </Button>
              )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          <Button href="#" data-test-id="pageTitle" className={classes.title} color="transparent">
            {makeBrand()}
          </Button>
        </div>
        <Hidden smDown implementation="css">
          <HeaderLinks />
        </Hidden>
        <Hidden mdUp>
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"])
};

export default withStyles(headerStyle)(Header);
